import { parseRuntime, ruleEngineRequest } from './impl-helper';

export const getIsSetupFactRender = async (params, almanac) => {
    const { variable, current } = await parseRuntime(params, almanac);
    //如果variable.UID == 0，没登陆，直接返回false
    let result = false;
    if (variable?.UID > 0) {
        const isSetup = await ruleEngineRequest(false, '/api/common/setup-user', {}, variable);
        result = isSetup === 1;
    }
    if (current.port.id === 'is-setup-port') {
        return result;
    } else if (current.port.id === 'is-not-setup-port') {
        return !result;
    }
    return false;
};
